import { useDataTable } from '../../../modules/table/DataTable';

const NfeStatusTabNav = () => {
  const { filter, updateFilter, clearFilter, dataAdditionalContent } = useDataTable();

  const handleTabClick = (statusUpdated?: string) => {
    if (statusUpdated) {
      updateFilter({ ...filter, status: statusUpdated });
    } else {
      clearFilter('status');
    }
  };

  return (
    <ul
      className="nav nav-tabs nav-line-tabs my-5 fs-6 d-flex flex-nowrap overflow-auto"
      style={{
        paddingBottom: '1px',
        scrollbarWidth: 'none', // Firefox
        msOverflowStyle: 'none', // IE 10+
        WebkitOverflowScrolling: 'touch',
      }}
    >
      <li className="nav-item">
        <a
          className={`d-flex flex-column align-items-center nav-link ${!filter?.status ? 'active fw-bold text-gray-600' : ''}`}
          role="button"
          onClick={() => handleTabClick()}
        >
          <span>todas</span>
        </a>
      </li>

      <li className="nav-item">
        <a
          className={`d-flex flex-column align-items-center nav-link ${filter?.status === 'AUTHORIZED' ? 'active fw-bold text-gray-600' : ''}`}
          role="button"
          onClick={() => handleTabClick('AUTHORIZED')}
        >
          <span>autorizada</span>
        </a>
      </li>
      <li className="nav-item">
        <a
          className={`d-flex flex-column align-items-center nav-link ${filter?.status === 'DENIED' ? 'active fw-bold text-gray-600' : ''}`}
          role="button"
          onClick={() => handleTabClick('DENIED')}
        >
          <span>negada</span>
        </a>
      </li>
    </ul>
  );
};

export default NfeStatusTabNav;
